module.exports = __webpack_public_path__ + "img/beauty-advice.95b911b9.png";